import { css } from '@emotion/react';
import { LocationDetails } from 'models';
import Skeleton from 'react-loading-skeleton';
import { Airport } from 'shared';

import { theme } from '../theme';

import { AirportName } from './AirportName';
import { DescriptionItem } from './DescriptionItem';

const styles = {
  airports: css`
    display: flex;
    gap: ${theme.spacing.xs};
    max-width: calc(100% - 110px);
  `,
};

type AirportsProps = {
  origin: LocationDetails;
  destination: LocationDetails;
};

export function Airports({ origin, destination }: AirportsProps) {
  return (
    <>
      <DescriptionItem label="From">
        <AirportName {...origin} />
      </DescriptionItem>

      <DescriptionItem label="To">
        <AirportName {...destination} />
      </DescriptionItem>
    </>
  );
}

type AirportsCompactProps = {
  loading: boolean;
  origin: Omit<Airport, 'regionName' | 'regionCode'> | undefined;
  destination: Omit<Airport, 'regionName' | 'regionCode'> | undefined;
};

export function AirportsCompact({ loading, origin, destination }: AirportsCompactProps) {
  if (loading) {
    <div css={styles.airports}>
      <Skeleton style={{ width: 100 }} />
      <div>{'-'}</div>
      <Skeleton style={{ width: 100 }} />
    </div>;
  }

  return (
    <div css={styles.airports}>
      {origin && <AirportName {...origin} />}
      <div>{'-'}</div>
      {destination && <AirportName {...destination} />}
    </div>
  );
}
